"use client";

import { useState } from "react";
import { Printer, Sparkle } from "@phosphor-icons/react";

const worksheetActs = [
  { title: "第一幕 · 导入与建立", prompt: "什么事件让主角再也回不到开场状态？", placeholder: "例如：一次错误委托，把主角和最不想合作的人绑在一起……" },
  { title: "第二幕 · 追求与试探", prompt: "主角想要什么？关系为何开始靠近？", placeholder: "写下外部目标，以及第一次愿意相信对方的具体行动……" },
  { title: "第三幕 · 逼近与失去", prompt: "最接近成功时，哪种信任被打碎？", placeholder: "让危机同时击中目标与关系，但两者不必在同一刻触底……" },
  { title: "第四幕 · 最终决战", prompt: "主角用什么不可逆的选择证明改变？", placeholder: "结局不是得到奖励，而是主角终于做出开场时做不到的选择……" },
] as const;

export function StoryWorksheet() {
  const [filled, setFilled] = useState(() => worksheetActs.map(() => false));
  const filledCount = filled.filter(Boolean).length;

  const updateFilled = (index: number, value: string) => {
    const next = [...filled];
    next[index] = value.trim().length > 0;
    setFilled(next);
  };

  return (
    <div className="story-worksheet card-surface mt-12 overflow-hidden rounded-[var(--radius-xl)]">
      <div className="flex flex-col gap-5 border-b border-[var(--color-line)] p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
        <div>
          <div className="flex items-center gap-2 text-sm font-medium text-[var(--color-paper)]"><Sparkle size={17} weight="duotone" aria-hidden="true" />故事骨架草稿</div>
          <p className="mt-2 text-sm text-[var(--color-mist)]">已完成 {filledCount} / {worksheetActs.length} 幕关键选择</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="h-1.5 w-32 overflow-hidden rounded-full bg-[var(--color-surface-3)]" aria-hidden="true">
            <div className="h-full rounded-full bg-gradient-to-r from-[var(--color-cool)] to-[var(--color-warm)] transition-[width] duration-300" style={{ width: `${(filledCount / worksheetActs.length) * 100}%` }} />
          </div>
          <button type="button" onClick={() => window.print()} className="inline-flex items-center gap-2 rounded-[var(--radius-pill)] border border-[var(--color-line-strong)] px-4 py-2 text-xs text-[var(--color-paper)] transition-colors hover:bg-[var(--color-surface-3)]">
            <Printer size={15} aria-hidden="true" />打印
          </button>
        </div>
      </div>

      <div className="grid lg:grid-cols-2">
        {worksheetActs.map((act, index) => (
          <label key={act.title} className={`block p-6 sm:p-8 ${index % 2 === 1 ? "lg:border-l lg:border-[var(--color-line)]" : ""} ${index > 1 ? "border-t border-[var(--color-line)]" : index === 1 ? "border-t border-[var(--color-line)] lg:border-t-0" : ""}`}>
            <span className="font-mono text-xs uppercase tracking-[0.14em] text-[var(--color-faint)]">{act.title}</span>
            <span className="mt-3 block text-base font-medium text-[var(--color-paper)]">{act.prompt}</span>
            <textarea rows={5} onChange={(event) => updateFilled(index, event.currentTarget.value)} placeholder={act.placeholder} className="mt-5 w-full resize-y rounded-[var(--radius-card)] border border-[var(--color-line-strong)] bg-[var(--color-ink)] px-4 py-3 text-sm leading-relaxed text-[var(--color-paper)] placeholder:text-[var(--color-ghost)] focus:border-[var(--color-accent)] focus:outline-none" />
          </label>
        ))}
      </div>
    </div>
  );
}
